<h4 class="dialog-title text-center">{{ 'Add Device Version' | translate }}</h4>

<hr />

<div class="mb-4">
    <div mat-dialog-content>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field>
                    <mat-label>{{ 'Version' | translate }}</mat-label>
                    <input matInput [(ngModel)]="deviceVersion.version" required />
                    <mat-icon matPrefix class="mr-3">
                        <i class="fas fa-code"></i>
                    </mat-icon>
                    <mat-error>{{ 'Version is required' | translate }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div mat-dialog-actions align="end">
        <button mat-button class="btn button-primary" (click)="create()" [class.button-spinner]="isLoading"
            [disabled]="!deviceVersion.version || isLoading">
            {{ 'Add' | translate }}
        </button>

        <button mat-button class="btn button-accent" mat-dialog-close>{{ 'Cancel' | translate }}</button>
    </div>
</div>
